import { Modal } from "antd";
import type { ModalStaticFunctions } from "antd/es/modal/confirm";

let modal: Omit<ModalStaticFunctions, "warn">;

// this is needed for modal.confirm to get the theme settings
export default () => {
  const [modalHook, contextHolder] = Modal.useModal();
  modal = modalHook;
  return contextHolder;
};

export { modal };
